export enum EditDiscountFormField {
  DiscountPerBooking = 'discountPerBooking',
}

export type EditDiscountFormValues = {
  [EditDiscountFormField.DiscountPerBooking]: number;
};
